import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import GenericMealPlanNutritionPage from './GenericMealPlanNutritionPage';

const MealPlanningGenericMealPlanPage: React.FC = () => {
  const navigate = useNavigate();
  const { planId = '', dayNumber = '1' } = useParams<{ planId: string; dayNumber: string }>();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get('clientId')?.trim() || '';
  const selectedDayNumber = Number(dayNumber) || 1;

  const goBackToMealPlanning = React.useCallback(() => {
    navigate('/generic-meal-plans');
  }, [navigate]);

  return (
    <GenericMealPlanNutritionPage
      planId={planId}
      clientId={clientId}
      dayNumber={selectedDayNumber}
      onBack={goBackToMealPlanning}
    />
  );
};

export default MealPlanningGenericMealPlanPage;
